<template>
  <div class="full-width-text">
    <h2 class="full-width-text__header">{{data.header}}</h2>
    <div class="full-width-text__text">
      <rich-text :textData="data.bodyTextContent" />
    </div>
  </div>
</template>

<script>
import RichText from './RichText.vue';

export default {
  components: {
    RichText,
  },
  props: [
    'data',
  ],
};
</script>

<style scoped>
.full-width-text {
  max-width: 720px;
  padding: 0 24px 42px 24px;
}

.full-width-text__header {
  width: 100%;
  margin: 48px 0 36px 0;
  font-family: var(--headline-font);
  font-weight: normal;
  font-size: 60px;
  line-height: 1;
  color: var(--dark-purple);
}

.full-width-text__text {
  margin: 24px 0 0 0;
}
</style>
